module.exports = __webpack_public_path__ + "static/media/SCLERANTHUS.8b32edab.JPG";